import * as angular from "angular";

export interface DateService {
  now(): Date;
}

class DateSvc implements DateService {
  now(): Date {
    return new Date();
  }
}

export default angular
  .module('date', [])
  .service('dateService', DateSvc)
  .name;



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--5!./src/app/services/utility/date.service.ts